import * as wxAutoReply from '../services/wxAutoReply';

export default {
  namespace: 'wxAutoReply',

  state: {
    appId: '',
  },

  effects: {
    //模板列表
    *getAppIdList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(wxAutoReply.getAppIdList, values);
      yield put({
        type: 'save',
        payload: {
          appIdList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //自动回复规则列表
    *getAutoReplyRulePage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(wxAutoReply.getAutoReplyRulePage, values);
      yield put({
        type: 'save',
        payload: {
          wxAutoReplyRuleData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //关注后自动回复
    *getAutoReplyPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(wxAutoReply.getAutoReplyPage, values);
      const wxAutoReplyList = response?.data?.rules;
      yield put({
        type: 'save',
        payload: {
          wxAutoReplyData: response?.data,
          wxAutoReplyList,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除模板消息
    *deleteReplyRule({ payload: { values }, callback }, { call }) {
      const response = yield call(wxAutoReply.deleteReplyRule, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //同步关注后自动回复规则
    *synSubscribeReply({ callback }, { call, select }) {
      const wxAutoReplyData = yield select(
        (state) => state.wxAutoReply.wxAutoReplyData,
      );
      const wxAutoReplyList = yield select(
        (state) => state.wxAutoReply.wxAutoReplyList,
      );
      const appId = yield select((state) => state.wxAutoReply.appId);
      const id = wxAutoReplyData?.appId || appId;
      const rules = wxAutoReplyList?.map((i) => i.id);
      const values = { ...wxAutoReplyData, appId: id, rules: rules };

      const response = yield call(wxAutoReply.synSubscribeReply, values);
      if (callback && typeof callback === 'function') {
        return callback(response, values);
      }
    },
    //实时检验自动回复是否被应用
    *checkUseReplyRule({ payload: { values }, callback }, { call }) {
      const response = yield call(wxAutoReply.checkUseReplyRule, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
